import React from 'react';
import { Navbar, Container, Nav, Button, NavDropdown } from 'react-bootstrap';
import { useLanguage } from './LanguageContext';
import translations from '../translations.json';
import './Navbar.css';

const CustomNavbar: React.FC = () => {
  const { language, setLanguage } = useLanguage();
  const t = translations[language]['navbar'];

  const handleSelectLanguage = (lang: 'en' | 'pl') => {
    setLanguage(lang);
  };

  return (
    <Navbar expand="lg" className="shadow-lg">
      <Container fluid>
        <Navbar.Toggle aria-controls="basic-navbar-nav" className="me-auto" />
        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
          <Nav className="ms-auto">
            <Nav.Link href="#about">{t.about}</Nav.Link>
            <Nav.Link href="#reviews">{t.reviews}</Nav.Link>
            <Button href="#contact" variant="btn btn-red">
              {t.contact}
            </Button>
            <NavDropdown
              title={<img src={`/img/flag/${language === 'pl' ? 'poland' : 'british'}.png`} alt="Lang" width="50" height="40" />}
              id="basic-nav-dropdown"
              align="end"
            >
              <NavDropdown.Item onClick={() => handleSelectLanguage('pl')}>
                <img src="/img/flag/poland.png" alt={t.language.polish} width="50" height="40" />
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleSelectLanguage('en')}>
                <img src="/img/flag/british.png" alt={t.language.english} width="50" height="40" />
              </NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default CustomNavbar;
